import type { FormInstance } from 'antd'

/**
 * 물류서비스타입을 고르면 화주를 비운다 — 1.0 SelectPicker 의 "화주유형 선택시 화주명 초기화"와 같다(LOGISPRD-17320).
 *
 * 빈 값(전체)으로 되돌릴 때는 비우지 않는다(1.0 도 값이 있을 때만 비웠다).
 *
 * 잠기지 않은 계정(통합 운영)만 비운다. 1.0 은 MUSINSA·MUSINSALOGISTICS 외 계정에서 화주유형 칸을 막아 이 경로가 없었다.
 * 화주를 고를 수 있느냐(canSelectShipper)로 가르면 안 된다 — 재고통합 29CM·INOOINT 는 잠긴 계정인데도 자기 화주와 MUSINSA 를
 * 고를 수 있어서, 비운 화주를 부모가 범위 보정(scopedShipperCode)하며 기본 화주 MUSINSA 로 바꿔 조회한다.
 */
export const clearShipperOnServiceType = (
  form: FormInstance,
  shipperField: string,
  scopeUnlocked: boolean,
  serviceType: string | null | undefined,
): void => {
  if (!scopeUnlocked || serviceType == null || serviceType === '') return
  form.setFieldValue(shipperField, undefined)
}
